export const NEW_QUESTIONNAIRE_ID = "new";

export const NEW_QUESTIONNAIRE_PREFIX = "questionnaire";
